import resources from "./resources";

const detectedLang = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : window.navigator.language.includes("es")
  ? "es"
  : "en";

document.documentElement.lang = detectedLang;

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: detectedLang,
  fallbackLng: "en", // Fallback to English when translation is missing
  debug: false, // Set to true for debugging missing translations
  resources,
};

export { resources };
